import type { FaireProductEntity } from "../../entity_types/product";

export const p_uyyh3xywd2: FaireProductEntity = {
  token: "p_uyyh3xywd2",
  type: "product",
  name: "LM-SP-1000 Sherpa - Light Pink/Bubblegum",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/5076dfa9773522114f0f339cdbd2862f2b958d30bb65f242689022b9687a8684.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/99538bc908cf05594f5e956b7ba42041b559828e7eb76b254c870899cb773e4d.jpeg"
  ],
  priceDollars: 39.5,
  description: "This cozy women's sweatshirt from Girlie Girl Originals features a sherpa lining and a soft light pink (bubblegum) hue for a playful, feminine touch. Designed for casual wear, it pairs easily with lounge wardrobes, providing warmth and a fashion-forward southern flair while reflecting the brand’s spirited attitude.",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:49.611Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
